import { Box } from '@mui/material'
import { observer } from 'mobx-react-lite'
import { Handle, NodeProps, Position, useEdges } from 'reactflow'
import { RoadNodeWithActions } from '../../models/yard-view.model'

const handleStyle = {
  opacity: 0,
  width: 0,
  height: 0,
  minWidth: 0,
  minHeight: 0,
  border: 'none',
  background: 'transparent',
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}

export const RoadNodeNode = observer(({ id, data }: NodeProps<RoadNodeWithActions>) => {
  const isGateOrAccessPoint = !!data.layoutObjectId || !!data.blockAccessPointId
  const edges = useEdges()
  const isJunction = edges.filter(e => e.source === id || e.target === id).length >= 3

  const handleContextMenu = (event: React.MouseEvent) => {
    event.preventDefault()
    data.onContextMenu(data.id, { x: event.clientX, y: event.clientY })
  }

  return (
    <Box
      data-road-node='true'
      onContextMenu={handleContextMenu}
      sx={{
        width: 10,
        height: 10,
        borderRadius: '50%',
        bgcolor: data.isPending ? 'info.main' : isGateOrAccessPoint ? 'primary.main' : 'grey.300',
        cursor: 'default',
        position: 'relative',
        boxShadow: isJunction ? '0 0 0 7px #2d2d2d' : undefined,
      }}
    >
      <Handle type='source' position={Position.Top} style={handleStyle} />
      <Handle type='source' position={Position.Bottom} style={handleStyle} />
      <Handle type='source' position={Position.Left} style={handleStyle} />
      <Handle type='source' position={Position.Right} style={handleStyle} />
      <Handle type='target' position={Position.Top} id='target-top' style={handleStyle} />
      <Handle type='target' position={Position.Bottom} id='target-bottom' style={handleStyle} />
      <Handle type='target' position={Position.Left} id='target-left' style={handleStyle} />
      <Handle type='target' position={Position.Right} id='target-right' style={handleStyle} />
    </Box>
  )
})
